"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfAdminAnnouncementRequestDto = instanceOfAdminAnnouncementRequestDto;
exports.AdminAnnouncementRequestDtoFromJSON = AdminAnnouncementRequestDtoFromJSON;
exports.AdminAnnouncementRequestDtoFromJSONTyped = AdminAnnouncementRequestDtoFromJSONTyped;
exports.AdminAnnouncementRequestDtoToJSON = AdminAnnouncementRequestDtoToJSON;
exports.AdminAnnouncementRequestDtoToJSONTyped = AdminAnnouncementRequestDtoToJSONTyped;
/**
 * Check if a given object implements the AdminAnnouncementRequestDto interface.
 */
function instanceOfAdminAnnouncementRequestDto(value) {
    if (!('title' in value) || value['title'] === undefined)
        return false;
    if (!('body' in value) || value['body'] === undefined)
        return false;
    return true;
}
function AdminAnnouncementRequestDtoFromJSON(json) {
    return AdminAnnouncementRequestDtoFromJSONTyped(json, false);
}
function AdminAnnouncementRequestDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'title': json['title'],
        'body': json['body'],
        'dedupeKey': json['dedupeKey'] == null ? undefined : json['dedupeKey'],
    };
}
function AdminAnnouncementRequestDtoToJSON(json) {
    return AdminAnnouncementRequestDtoToJSONTyped(json, false);
}
function AdminAnnouncementRequestDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'title': value['title'],
        'body': value['body'],
        'dedupeKey': value['dedupeKey'],
    };
}
